export * from './post-kunden-art.component';
export * from './post-kunden-art.component.module';